// angular
import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import { ScriptService } from '@aa/selfserv/shared/services';

// local
import { AbstractQnaComponent } from '../../abstract-qna.component';
import { QnaNavigationService } from '../../qna-navigation.service';

const SCRIPT_PATH = "https://www.moneyadviceservice.org.uk/assets/syndication/tools.js";

@Component({
  selector: 'aa-qna-money-manager',
  templateUrl: './money-manager.component.html'
})
export class QnaMoneyManagerPageComponent extends AbstractQnaComponent implements AfterViewInit {

  constructor(navigation: QnaNavigationService,
    private readonly scriptService: ScriptService,
    private readonly renderer: Renderer2,) {
    super(navigation, 'Money Manager');
  }

  ngAfterViewInit() {
    const scriptElement = this.scriptService.loadJsScript(this.renderer, SCRIPT_PATH);
    scriptElement.onload = () => {
     console.log('Money Helper script loaded');
    }
    scriptElement.onerror = () => {
      console.log('Could not load money helper script!');
    }
  }

}
